import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2115_162494",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2115_162494)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.9688 16.4521H21V17.9688H17.9688V21H16.4521V17.9688H13.4209V16.4521H16.4521V13.4209H17.9688V16.4521ZM14.7637 3C16.2328 3 17.4816 3.51459 18.5098 4.54297C19.538 5.57106 20.0526 6.8192 20.0527 8.28809V12.2881C19.6179 12.0365 19.1472 11.8398 18.6494 11.71V8.28809C18.6493 7.209 18.272 6.29153 17.5166 5.53613C16.7611 4.78064 15.843 4.40332 14.7637 4.40332H8.28809C7.20897 4.40341 6.29154 4.78073 5.53613 5.53613C4.78073 6.29154 4.40341 7.20897 4.40332 8.28809V14.7637C4.40332 15.843 4.78064 16.7611 5.53613 17.5166C6.29153 18.272 7.209 18.6493 8.28809 18.6494H11.71C11.8399 19.1474 12.0373 19.6178 12.2891 20.0527H8.28809C6.8192 20.0526 5.57106 19.538 4.54297 18.5098C3.51459 17.4816 3 16.2328 3 14.7637V8.28809C3.00009 6.81917 3.51469 5.57107 4.54297 4.54297C5.57107 3.51468 6.81917 3.00009 8.28809 3H14.7637ZM15.2812 9.47559L10.1504 14.5791L7.33984 11.7695L8.31543 10.7666L10.1504 12.5742L14.2783 8.47363L15.2812 9.47559Z",
			fill: "currentColor"
		})
	})]
});
export default SvgNewTask;
